import React from 'react';

export function VivahLogoIcon({ size = 46 }) {
  const dimensions = typeof size === 'number' ? size : size === 'large' ? 68 : size === 'small' ? 36 : 46;

  return (
    <svg
      width={dimensions}
      height={dimensions}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ filter: 'drop-shadow(0 4px 12px rgba(0, 121, 107, 0.25))' }}
    >
      <defs>
        <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F2D086" />
          <stop offset="50%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#8C6A23" />
        </linearGradient>
        <linearGradient id="tealGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0097a7" />
          <stop offset="100%" stopColor="#004d40" />
        </linearGradient>
      </defs>

      {/* Outer Ring */}
      <circle cx="50" cy="50" r="44" stroke="url(#goldGrad)" strokeWidth="3" fill="none" strokeDasharray="6 3" />

      {/* Inner Emerald Ring */}
      <circle cx="50" cy="50" r="38" fill="url(#tealGrad)" />

      {/* Interlocking Rings (Symbolizing Union) */}
      <circle cx="43" cy="50" r="15" stroke="url(#goldGrad)" strokeWidth="3" fill="none" />
      <circle cx="57" cy="50" r="15" stroke="url(#goldGrad)" strokeWidth="3" fill="none" />

      {/* Center Sparkle */}
      <path d="M50 38 L52 48 L62 50 L52 52 L50 62 L48 52 L38 50 L48 48 Z" fill="url(#goldGrad)" />
    </svg>
  );
}

export default function VivahLogo({ size = 'medium' }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem' }}>
      <VivahLogoIcon size={size} />
    </div>
  );
}
